import React from "react";
import Project from "./projet";

export function ProjectFenced() {
  return <Project status="Reporté" />;
}